import $ from "../libs/jquery-3.3.1.min.js"
import {gsap} from "../libs/gsap/all.js"
import * as PIXI from "pixi.js";

// Constructor
export class PixiVideoPlayer extends PIXI.Application {

	constructor() {

		super({
			width: 1080,
			height: 1080,
			// backgroundColor: 0x1099bb,
			backgroundColor: 0x000000,
			resolution: window.devicePixelRatio || 1,
			view: $("#pixi-app").get(0)
		});

		this.currentVideoId = -1;
		this.videoTextures = [];
		this.videos = [
			$("#pixi-video1").get(0),
			$("#pixi-video2").get(0),
			$("#pixi-video3").get(0),
			$("#pixi-video4").get(0),
		];

		// Main container
		this.mainContainer = new PIXI.Container();
		this.stage.addChild(this.mainContainer);

		// Black
		const dummyTexture = new PIXI.Texture.from('images/loading.jpg');

		// Sprite
		this.videoSprite = new PIXI.Sprite(dummyTexture)
		this.videoSprite.width = 1080
		this.videoSprite.height = 1080
		this.mainContainer.addChild(this.videoSprite);

		// Init video textures
		$.each(this.videos, (i, n) => {
			// https://pixijs.download/release/docs/PIXI.VideoResource.html
			this.videoTextures[i] = new PIXI.Texture.from(this.videos[i]);
			this.videoTextures[i].baseTexture.resource.autoLoad = false;
			this.videoTextures[i].baseTexture.resource.autoPlay = false;
		})


		// Listen for animate update
		// this.ticker.add((delta) => {
		// 	// rotate the container!
		// 	// use delta to create frame-independent transform
		// 	container.rotation -= 0.01 * delta;
		// });
	}

	playNow(src, callback, fade = false) {

		const currentVideoId = this.currentVideoId
		const nextVideoId = (currentVideoId + 1) % this.videos.length
		this.videos[nextVideoId].currentTime = 0;
		this.videos[nextVideoId].src = src;
		this.videos[nextVideoId].loop = true;

		this.resetTimeline();
		this.tl = new gsap.timeline();

		$(this.videos[nextVideoId]).off("canplaythrough ended");
		$(this.videos[nextVideoId]).one("canplaythrough", () => {

			if (fade) {
				this.tl.to(this.videoSprite, {
					alpha: 0,
					duration: 0.35
				});
			}

			this.tl.add(() => {
				this.swapOnTextureUpdate(currentVideoId, nextVideoId);
				this.videos[nextVideoId].play();
				this.currentVideoSrc = src;

				if (typeof callback == "function") {
					$(this.videos[nextVideoId]).one("ended", () => {
						callback();
					});
				}
			});

			if (fade) {
				this.tl.to(this.videoSprite, {
					alpha: 1,
					duration: 0.45
				}, "+=0.1");
			}

		});

		this.videos[nextVideoId].load();

		this.currentVideoId = nextVideoId;
	}


	playNowWithFade(src, callback) {
		this.playNow(src, callback, true);
	}

	playNext(src, callback) {
		const currentVideoId = this.currentVideoId

		if (this.currentVideoSrc == src) {
			console.log("same video, skip")
			this.videos[currentVideoId].play();
			return;
		}

		const nextVideoId = (currentVideoId + 1) % this.videos.length
		this.videos[nextVideoId].currentTime = 0;
		this.videos[nextVideoId].src = src;
		this.videos[nextVideoId].loop = true;

		$(this.videos[nextVideoId]).off("canplaythrough ended");
		$(this.videos[nextVideoId]).one("canplaythrough", () => {
			this.videos[currentVideoId].loop = false;
			$(this.videos[currentVideoId]).one("ended", () => {
				// this.videos[nextVideoId].currentTime = 0;
				console.log("swap to from " + currentVideoId + " to " + nextVideoId, src, this.videos[nextVideoId].currentTime)
				this.swapOnTextureUpdate(currentVideoId, nextVideoId);
				this.videos[nextVideoId].play();
				this.currentVideoSrc = src;

				if (typeof callback == "function") {
					$(this.videos[nextVideoId]).one("ended", () => {
						callback();
					});
				}
			});
		});

		this.videos[nextVideoId].load();

		this.currentVideoId = nextVideoId;
	}

	disposeCurrentVideo(videoId) {
		if (videoId != -1) {
			this.videos[videoId].pause();
			this.videos[videoId].src = "";
			this.videos[videoId].load();
			this.videoTextures[videoId].baseTexture.dispose();
			// this.videoTextures[videoId].baseTexture.clear();
		}
	}

	swapOnTextureUpdate(currentVideoId, nextVideoId) {
		this.videoTextures[nextVideoId].once("update", () => {
			this.videoTextures[nextVideoId].baseTexture.update();
			this.videoTextures[nextVideoId].update();
			requestAnimationFrame(() => {
				this.videoSprite.texture = this.videoTextures[nextVideoId]
				this.disposeCurrentVideo(currentVideoId);
			})
		})
	}

	resetTimeline() {
		if (this.tl) {
			this.tl.kill();
			this.tl = null;
		}
	}


}
